module.exports = __webpack_public_path__ + "static/media/aboutyili.df80d926.png";